import JoyDivider, { DividerProps as JoyDividerProps } from '@mui/joy/Divider';
import { useTheme } from '@mui/joy';

interface DividerProps extends JoyDividerProps {
  width?: number | string;
}

export const Divider = ({ width = '100%', ...props }: DividerProps) => {
  const theme = useTheme();
  return (
    <JoyDivider
      sx={{
        width: width,
        bgcolor: theme.palette.chartElementsBackground.baseLine,
      }}
      {...props}
    />
  );
};
